import { GeneralTable } from "@/shared/components/ui";
import { useMemo, useState } from "react";
import { useTableColumnsConsultasPorTipo } from "./useTableColumnsConsultasPorTipo";
import DialogLiberarPuerto from "./DialogLiberarPuerto";

type TablaConsultasPorTipoProps = {
    allData: any;
    isLoading: boolean;
    onSearch: () => Promise<boolean | undefined>;
};

export default function TablaConsultasPorTipo({
    allData,
    isLoading,
    onSearch
}: TablaConsultasPorTipoProps) {

    // Paginación para Material React Table (manejada internamente por la tabla)
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    const filteredData = useMemo(() => {
        let data = allData;
        return data;
    }, [allData]);

    const paginatedData = useMemo(() => {
        const startIdx = pagination.pageIndex * pagination.pageSize;
        const endIdx = startIdx + pagination.pageSize;
        return filteredData.slice(startIdx, endIdx);
    }, [filteredData, pagination.pageIndex, pagination.pageSize]);

    const {
        columnBase,
        dataPuerto,
        openActividadesModal,
        setOpenActividadesModal
    } = useTableColumnsConsultasPorTipo({ pagination });

    return (
        <>
            <GeneralTable
                columns={columnBase}
                data={paginatedData}
                isLoading={isLoading}
                pagination={pagination}
                onPaging={setPagination}
                rowCount={filteredData.length}
                enableColumnActions={false}
                enableEditing={false}
                enableGlobalFilter={false}
                enableColumnFilters={true}
            />
            {/* ----------- Modals ----------- */}
            {
                openActividadesModal && (
                    <DialogLiberarPuerto
                        open={openActividadesModal}
                        setOpen={setOpenActividadesModal}
                        dataPuerto={dataPuerto}
                        onSearch={onSearch}
                    />
                )
            }
        </>
    )
}